import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';

import NewRequestForm from './pages/new-request-form';
import DashboardOverview from './pages/dashboard-overview';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTpo';
import RequestsManagement from './pages/requests-management';
import LoginAuthentication from './pages/login-authentication';
import RequestDetails from './pages/request-details';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          // <Route path="/" element={<LoginAuthentication />} />
          <Route path="/new-request-form" element={<NewRequestForm />} />
          <Route path="/dashboard-overview" element={<DashboardOverview />} />
          <Route path="/requests-management" element={<RequestsManagement />} />
          <Route
            path="/login-authentication"
            element={<LoginAuthentication />}
          />
          <Route
            path="/requests-management/request-details"
            element={<RequestDetails />}
          />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
